import type { Catalog } from "./en";
import { adminScreens } from "./fil/admin-screens";
import { admin } from "./fil/admin";
import { auth } from "./fil/auth";
import { consoleShell } from "./fil/console";
import { deployKnowledge } from "./fil/deploy-knowledge";
import { onboarding } from "./fil/onboarding";
import { billing } from "./fil/billing";
import { dashboard } from "./fil/dashboard";
import { engage } from "./fil/engage";
import { guide } from "./fil/guide";
import { knowledgeGraph } from "./fil/knowledge-graph";
import { build } from "./fil/build";
import { roles } from "./fil/roles";
import { service } from "./fil/service";
import { settings } from "./fil/settings";
import { team } from "./fil/team";
import { webapp } from "./fil/webapp";
// M29 namespaces (WP-M29-SCHEMA1 shells; later work packages add keys).
import { agentReports } from "./fil/agent-reports";
import { customerContext } from "./fil/customer-context";
import { glossary } from "./fil/glossary";
import { launch } from "./fil/launch";
import { webappLaunch } from "./fil/webapp-launch";
import { packs } from "./fil/packs";
import { privacyM29 } from "./fil/privacy-m29";
// M29 Phase 2 namespaces (WP-M29-SCHEMA2 shells).
import { routingLive } from "./fil/routing-live";
import { segments } from "./fil/segments";
import { wallboard } from "./fil/wallboard";
import { webappStudio } from "./fil/webapp-studio";

/** Filipino strings (product terms such as Inbox / Dashboard are kept as commonly used in PH workplaces). */
export const fil: Catalog = {
  auth,
  onboarding,
  console: consoleShell,
  roles,
  service,
  team,
  dashboard,
  billing,
  settings,
  admin,
  adminScreens,
  deployKnowledge,
  engage,
  guide,
  knowledgeGraph,
  build,
  webapp,
  launch,
  webappLaunch,
  customerContext,
  privacyM29,
  packs,
  glossary,
  agentReports,
  routingLive,
  wallboard,
  webappStudio,
  segments,
  common: {
    retry: "Subukan muli",
    copy: "Kopyahin",
    copied: "Nakopya na",
    close: "Isara",
    loading: "Naglo-load…",
    comingSoon: "Malapit na",
    backToDashboard: "Bumalik sa dashboard",
    cancel: "Kanselahin",
    save: "I-save",
    optional: "(opsyonal)",
    timeRange: { "7d": "7 araw", "30d": "30 araw", "90d": "90 araw" },
    countries: {
      placeholder: "Pumili ng bansa",
      search: "Maghanap ng bansa…",
      empty: "Walang bansang tumutugma sa hinanap mo",
      loadError: "Hindi ma-load ang listahan ng mga bansa.",
    },
    timezones: {
      inCountry: "Mga time zone sa {{country}}",
      all: "Lahat ng time zone",
    },
    upload: {
      unreachable: "Hindi maabot ang file storage. Tingnan ang koneksyon at subukan muli.",
      rejected: "Tinanggihan ng file storage ang upload. Subukan muli.",
      storageError: "May problema ang file storage. Subukan muli sandali.",
      cancelled: "Nakansela ang upload.",
      failed: "Hindi natapos ang upload. Subukan muli.",
      reference: "Sanggunian: {{reference}}",
    },
  },
  shell: {
    skipToContent: "Lumaktaw sa nilalaman",
    openMenu: "Buksan ang menu",
    closeMenu: "Isara ang menu",
    sidebar: "Sidebar",
    mainNav: "Pangunahing nabigasyon",
    breadcrumb: "Breadcrumb",
    search: "Maghanap o pumunta sa…",
    searchShortcut: "Ctrl K",
    help: "Tulong",
    notifications: "Mga abiso",
    unread: "hindi pa nababasa",
    markAllRead: "Markahang nabasa lahat",
    allMarkedRead: "Namarkahang nabasa ang lahat ng abiso",
    workspaces: "Mga workspace",
    newWorkspace: "Bagong workspace",
    switchWorkspace: "Lumipat ng workspace",
    activeAgent: "Aktibong agent",
    switchAgent: "Lumipat ng agent",
    manageAgents: "Pamahalaan ang lahat ng agent",
    createAgent: "Gumawa ng agent",
    messagesThisMonth: "Mga mensahe ngayong buwan",
    resets: "Magre-reset sa {{date}}",
    upgrade: "Mag-upgrade",
    usageUnlimited: "Walang limitasyon",
    usageUsed: "{{value}} ang nagamit",
    usageLow: "Paubos na · {{value}} ang natitira",
    usageLimitReached: "Naabot na ang limitasyon",
    userMenu: "Menu ng account",
    myProfile: "Aking profile",
    platformAdmin: "Platform admin (CRUD.IT)",
    tenantConsole: "Tingnan ang tenant console",
    logOut: "Mag-log out",
    platformAdminBadge: "Platform Admin",
  },
  palette: {
    title: "Command palette",
    placeholder: "Pumunta sa page, agent, o setting…",
    empty: "Walang tugma",
    navigate: "lumipat",
    open: "buksan",
  },
  theme: {
    toggle: "Palitan ang tema",
    heading: "Tema",
    light: "Maliwanag",
    dark: "Madilim",
    system: "Sistema",
  },
  nav: {
    overview: "Pangkalahatan",
    build: "Buuin",
    deploy: "I-deploy",
    engage: "Makipag-ugnayan",
    workspace: "Workspace",
    help: "Tulong",
    platform: "Platform",
    commercial: "Komersyal",
    "ai-platform": "AI Platform",
    operations: "Operasyon",
    dashboard: "Dashboard",
    inbox: "Inbox",
    analytics: "Analytics",
    playground: "Playground",
    knowledge: "Knowledge Base",
    "knowledge-graph": "Knowledge graph",
    "agent-settings": "Settings ng Agent",
    actions: "Mga Aksyon",
    evaluations: "Mga Ebalwasyon",
    "widget-studio": "Widget Studio",
    "webapp-studio": "Web App Studio",
    channels: "Mga Channel",
    gaps: "Mga Kakulangan sa Kaalaman",
    leads: "Leads at Inquiries",
    workflows: "Workflows",
    announcements: "Mga Anunsyo",
    wallboard: "Wallboard",
    service: "Serbisyo",
    tickets: "Mga Ticket",
    organisations: "Mga Organisasyon",
    contacts: "Mga Contact",
    assets: "Mga Asset",
    installations: "Mga Installation",
    visits: "Mga Pagbisita sa Field",
    orders: "Mga Order",
    catalogue: "Katalogo",
    "service-reports": "Mga Ulat sa Serbisyo",
    "service-settings": "Settings ng Serbisyo",
    audiences: "Audience at Access",
    team: "Team",
    billing: "Billing at Paggamit",
    settings: "Settings",
    guide: "Gabay sa Paggamit",
    tenants: "Mga Tenant",
    usage: "Paggamit at Gastos",
    plans: "Mga Plano at Presyo",
    "sales-requests": "Mga sales request",
    "ai-models": "Mga AI Provider at Model",
    system: "Kalusugan ng Sistema",
    support: "Suporta",
    audit: "Audit Logs",
    staff: "Platform Staff",
    "platform-settings": "Settings ng Platform",
  },
  pages: {
    placeholderTitle: "Darating ang screen na ito sa susunod na yugto",
    placeholderBody: "Nakaplano ang {{page}} sa build plan. Handa na ang nabigasyon, permissions at shell.",
    notFoundTitle: "Hindi nahanap ang page",
    notFoundBody: "Maaaring luma na ang link, o wala kang access sa page na ito.",
    adminDashboardTitle: "Platform dashboard",
    adminDashboardSubtitle: "Pangkalahatang-tanaw ng CRUD.IT platform. Ikokonekta ang live metrics sa susunod na yugto.",
  },
  chat: {
    streamingSoon: "Ikokonekta ang live na sagot sa susunod na release.",
    newChat: "Bagong chat",
    share: "Ibahagi",
    messageLabel: "Mensahe",
    placeholder: "Magtanong tungkol sa admission, bayarin, dokumento…",
    send: "Ipadala",
    attach: "Mag-attach ng file",
    voice: "Boses",
    enterToSend: "para ipadala",
    newLine: "bagong linya",
    poweredBy: "Pinapagana ng {{product}}",
    disclaimer: "Galing sa opisyal na dokumento ang mga sagot. Laging kumpirmahin ang bayarin sa kinauukulang opisina.",
    greeting: "Hi! Paano kita matutulungan ngayon?",
    greetingSub: "Magtanong sa English, Filipino o Taglish. Sumasagot ako mula sa opisyal na dokumento at ipinapakita ang pinagmulan.",
    openWidget: "Buksan ang chat",
    closeWidget: "Isara ang chat",
    related: "Mga kaugnay na tanong",
    workflow: {
      choose: "Pumili ng opsyon",
      chosen: "Ang pinili mo",
      submit: "Magpatuloy",
      skip: "Laktawan",
      select: "Pumili…",
      required: "Kailangan ang field na ito.",
      invalidEmail: "Maglagay ng wastong email address.",
      invalidPhone: "Maglagay ng wastong phone number, hal. +63 917 123 4567.",
      invalidNumber: "Maglagay ng numero.",
      invalidDate: "Pumili ng wastong petsa.",
      invalidOption: "Pumili ng isa sa mga opsyon.",
      invalidFromServer: "Mukhang hindi tama iyon. Pakisuri at subukan ulit.",
      expired: "Sarado na ang tanong na ito. I-type ang mensahe mo para magpatuloy.",
      privacyLink: "Basahin ang privacy notice",
      answeredWith: "Sinagot mo: {{value}}",
      typingLocked: "Pumili ng opsyon sa itaas",
      replyAnswer: "Sagot: {{question}}",
      replyPlaceholder: "I-type ang sagot ninyo",
      ratingGroup: "Ang rating mo",
      rateStar: "I-rate ng {{n}} sa 5",
      starsOutOf: "{{n}} sa 5",
      thumbsUp: "Thumbs up",
      thumbsDown: "Thumbs down",
      ratingComment: "May idadagdag ka ba? (opsyonal)",
      ratingCommentCount: "{{used}} sa {{max}} na character",
      ratingSubmit: "Ipadala",
      ratingSelected: "Napili: {{rating}}",
      verifyGroup: "I-verify ang e-mail ninyo",
      sendCode: "Ipadala ang code",
      resendCode: "Ipadala ulit ang code",
      codeWillGoTo: "Magpapadala kami ng 6-digit na code sa {{email}}.",
      codeSentTo: "Nagpadala kami ng code sa {{email}}. I-type ito sa message box.",
      codeExpiresAt: "Gagana ang code hanggang {{time}}.",
      triesLeft_one: "{{count}} subok na lang",
      triesLeft_other: "{{count}} subok na lang",
      resendIn: "Puwede kayong humingi ng bagong code sa loob ng {{seconds}} s.",
      resendReady: "Puwede na kayong humingi ng bagong code.",
      securityCheck: "Security check",
      securityCheckWait: "Hintayin munang matapos ang security check, saka subukan ulit.",
      invalidCode: "Ilagay ang {{length}}-digit na code mula sa e-mail.",
      articleGroup: "Artikulo: {{title}}",
      articleNewTab: "(bumubukas sa bagong tab)",
    },
  },
};
